import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  EventEmitter,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StepsModule } from 'primeng/steps';

@Component({
  selector: 'app-base-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, StepsModule],
})
export class BaseStepperComponent implements OnInit, OnChanges {
  @Input() steps: {
    label: string;
    routerLink?: string;
    id?: string;
    moduleCode?: string;
  }[] = [];
  @Input() activeIndex: number = 0;
  @Input() direction: 'vertical' | 'horizontal' = 'horizontal';
  @Input() readonly: boolean = true;
  @Output() onTabChanged = new EventEmitter<number>();

  translatedSteps = this.steps;

  constructor(
    private elRef: ElementRef,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.updateTranslate();
    this.translateService.onLangChange.subscribe((_) => {
      this.updateTranslate();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['activeIndex']) {
      const stepItems =
        this.elRef.nativeElement.querySelectorAll('.p-steps-item');
      const previousValue = changes['activeIndex'].previousValue;
      const currentValue = changes['activeIndex'].currentValue;
      if (previousValue != undefined && previousValue < currentValue) {
        let previousStep = stepItems[changes['activeIndex'].previousValue];
        previousStep.querySelector('.p-steps-number').classList.add('marked');
      }
      if (previousValue != undefined && previousValue > currentValue) {
        let previousStep = stepItems[changes['activeIndex'].previousValue];
        previousStep
          .querySelector('.p-steps-number')
          .classList.remove('marked');
      }
    }
  }

  onActiveIndexChange(event: any) {
    if (!this.readonly) {
      this.onTabChanged.emit(event);
    }
  }

  private updateTranslate() {
    this.translatedSteps = this.steps.map((step) => ({
      ...step,
      label: this.translateService.instant(step.label),
    }));
  }
}
